
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ICardMemberModel, ICardModel } from '../../../models/member_card.model';

@Component
export default class membershipLoginForm extends Vue {

  @Prop() hasToken: boolean;
  @Prop() currentMember: ICardMemberModel | null;
  @Prop() currentCard: ICardModel | null;

  public memberFormModel = false;
  public cardNumber: number | string | string[] |  null = null;
  public verificationCode = null;
  public showActivationForm = false;
  public emailModel: string | string[] | null = null;
  public emailRules = [
    v => !!v || 'E-mail is required',
    v => /.+@.+/.test(v) || 'E-mail must be valid',
  ];
  public cardNumberRules = [
    v => /^[-+]?[0-9]*\.?[0-9]*$/.test(v) || 'Only digital'
  ];

  async onSubmit(e: Event) {
    e.preventDefault();
    await this.$refs.memberCardForm.validate();
    if (!this.currentMember && !this.hasToken) {
      if (!this.memberFormModel) return;
      if(this.verificationCode) {
          this.$emit('sumbitVerificationCode', this.verificationCode);
          return
      }
      this.$emit('sumbitMemberForm', {email: this.emailModel, cardNumber: this.cardNumber });
    } else if (this.hasToken) {
      if (!this.verificationCode) return;
      this.$emit('sumbitVerificationCode', this.verificationCode);
      this.verificationCode = null;
    } else if (this.verificationCode) {
        this.$emit('sumbitVerificationCode', this.verificationCode);
    }
  }

  getPrefillForm() {
    const currentQuery = this.$route?.query;
    if(currentQuery && currentQuery.hasOwnProperty('emailModel')){
        this.emailModel = currentQuery.emailModel;
    }
    if(currentQuery && currentQuery.hasOwnProperty('cardNumber') ) {
        this.cardNumber = currentQuery.cardNumber;
    }

    if(this.hasToken) {
      this.showActivationForm = true
    }

  }

  triggerView(state: boolean) {
    this.showActivationForm = state;
  }

  mounted() {
    this.getPrefillForm();
  }

}
